
import Box from '@mui/material/Box';
import { SxProps } from "@mui/material";

type BoxedImageProps = {
  src: string,
  alt?: string,
  width: string,
  height: string,
  padding?: string,
  sx?: SxProps,
};

export const BoxedImage = ({
  src,
  width,
  height,
  padding = '5.33px',
  sx,
  ...rest
}: BoxedImageProps) => {
  return (
    <Box
      component="img"
      src={src}
      sx={{
        width,
        height,
        objectFit: 'contain',
        backgroundColor: 'transparent',
        padding,
        ...sx,
      }}
      {...rest}
    />
  );
};